import type { PendingChoice } from "../types/index.js";
import { innRequiredCount } from "../reducer/resolveInn.js";

export function canSubmitInn(
  pending: PendingChoice | null,
  handLength: number,
): boolean {
  if (pending?.kind !== "inn") return true;
  return pending.selected.length === innRequiredCount(handLength);
}
